import {Component, Injectable, OnDestroy, OnInit} from '@angular/core';
import { MenuServices } from 'src/app/services/menu-service.services';
import { NavItem, NavItemEntitiesTypeEnum } from 'src/app/interfaces/nav-item';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzTreeNode, NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { Observable, Subscription } from 'rxjs';
import { IconServices } from 'src/app/services/icon.services';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { FormItemConfiguration } from 'src/app/system-utils/form-item-component/form-item-component.component';
import { FormServices } from 'src/app/services/form.services';
import { HTTPService } from 'src/app/services/http.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ThemeService } from 'src/app/services/theme.service';
import { REGISTRY } from 'src/app/interfaces/registry-services';

@Component({
    selector: 'menu-creator',
    templateUrl: "./menu-creator.component.html",
    styleUrls: ["./menu-creator.component.scss"],
    standalone: false
})

export class MenuCreatorComponent implements OnInit,  OnDestroy {


  hideProperties:boolean = true;
  disableSave:boolean = true;
  showEditView = false;
  form:FormGroup;
  icons:Object[] = [];
  entities:Object[] = [];
  subIcon:Subscription;
  typeIcon:{id:string, name:string}[]=[
    {
      id:'google',
      name:'Google',
    },
    {
      id:'svg',
      name:'SVG'
    }
  ];

  /** árvore NG-ZORRO (substitui o mat-tree/FlatTreeControl) */
  nodes: NzTreeNodeOptions[] = [];
  /** spinner NG-ZORRO (substitui o ngx-spinner 'menucreator') */
  menuLoading = false;
  private keySeq = 0;

  private buildNodes(items: NavItem[]): NzTreeNodeOptions[] {
    return (items || []).map(item => {
      const children = this.buildNodes(item.children);
      return {
        title: item.displayName,
        key: 'menu_' + (this.keySeq++),
        navItem: item,
        isLeaf: children.length === 0,
        children: children,
        selectable: false
      } as NzTreeNodeOptions;
    });
  }

  private setTreeData(items: NavItem[]): void {
    this.keySeq = 0;
    this.nodes = this.buildNodes(items);
  }

  entityList:Object[] = [];
  selectedTypeItem = null;
  typeItem:{key:string, name:string, enable:boolean}[]=[
      {
        key:'R',
        name:"Root",
        enable:false
      },
      {
        key:'P',
        name:"Pasta",
        enable:true
      },
      {
        key:'I',
        name:"Item",
        enable:true
      }
  ]

  formItemConfiguration:FormItemConfiguration[]= [];

  selectedRow: NavItem;
  selectedTypeIcon:string;
  mode: string;
  selectFatherItem: NavItem;

  constructor(
    private menuService:MenuServices,
    private formBuilder:FormBuilder,
    private iconServices:IconServices,
    private snackbar:SnackbarService,
    private formServices:FormServices,
    private http:HTTPService,
    public ThemeService:ThemeService,
    private dialogServices:DialogService
    ) {

      this.menuService.getNewMenu().then(async (d:NavItem[])=>{
        this.setTreeData(d);
        await this.loadInstances().then(d=>{
          this.formItemConfiguration = [
            {
              name:"type",
              description: "Tipo de Campo",
              title:"Tipo",
              tooltip:"Informar o Tipo de Campo",
              type:"select",
              required:true,
              options:Object.keys(JSON.parse(JSON.stringify(NavItemEntitiesTypeEnum))).map(d=>{return {key:JSON.parse(JSON.stringify(NavItemEntitiesTypeEnum))[d],value:JSON.parse(JSON.stringify(NavItemEntitiesTypeEnum))[d]}}),
            },
            {
              name:"idDashBoard",
              description: "DashBoard",
              title:"DashBoard",
              tooltip:"Selecionar DashBoard",
              type:"search",
              entityName:"Mktpdashboard",
              columnName:"INTERNALID",
              controlName:"idDashBoard",
              entityDesc:"DashBoards",
              fieldName:"NAME",
              required:true,
              colDef:{
                    flex:1,
                    resizable:true
              },
              hideFunction:(form:FormGroup)=>{
                let type:NavItemEntitiesTypeEnum = form.get('type').value;
                if ( type == NavItemEntitiesTypeEnum.dashboard ){
                  return false;
                }else{
                  return true;
                }
              }
            },
            {
               name:"entityName",
               description: "Nome da Entidade/Tabela",
               title:"Nome da Entidade",
               tooltip:"Selecionar a Entidade/Tabela",
               type:"select",
               required:true,
               hideFunction:(form:FormGroup)=>{
                let type:NavItemEntitiesTypeEnum = form.get('type').value;
                if ( type==NavItemEntitiesTypeEnum.dashboard || type==NavItemEntitiesTypeEnum.component ){
                    return true;
                }else{
                  return false;
                }
               },
               options:this.entityList.map(d=>{return {key:d['INSTANCENAME'],value:d['INSTANCEDESC']}}),
               colDef:{
                   flex:1,
                   resizable:true
               }
             },
             {
               name:"titleInstance",
               description: "Título da Tela",
               title:"Título da Tela",
               tooltip:"Informar o Título da Tela",
               type:"string",
               required: true,
               colDef:{
                   flex:1,
                   resizable:true
               }
             },
             {
               name:"condition",
               description: "Condição Fixa da Instância",
               title:"Condição da Instância",
               tooltip:"Informar a condição fixa da instância",
               type:"string",
               required: true,
               hideFunction:(form:FormGroup)=>{
                let type:NavItemEntitiesTypeEnum = form.get('type').value;
                if ( type==NavItemEntitiesTypeEnum.dashboard || type==NavItemEntitiesTypeEnum.component){
                  return true;
                }else{
                  return false;
                }
              }
             },
             {
               name:'order',
               description: 'Ordem',
               title:'Ordem',
               tooltip:'Ordem Inicial das Abas',
               type:'number',
               required: true,
               colDef:{
                flex:1,
                resizable:true
               }
             },
             {
               name:"canAccess",
               description: "Pode Acessar",
               title:"Pode Acessar?",
               tooltip:"Informar se a aba estará disponível para todos os usuários.",
               type:"toggle",
               defaultValue:false,
               required: false
             },
             {
               name:"nodata",
               description: "Carregar Dados na Inicialização",
               title:"Carregar Dados?",
               tooltip:"Informar se carrega dados na inicialização do componente.",
               type:"toggle",
               required: false,
               defaultValue:false,
               hideFunction:(form:FormGroup)=>{
                let type:NavItemEntitiesTypeEnum = form.get('type').value;
                if ( type==NavItemEntitiesTypeEnum.dashboard || type==NavItemEntitiesTypeEnum.component){
                  return true;
                }else{
                  return false;
                }
              }
             },
             {
              name:"showImageData",
              description: "Carregar Coluna",
              title:"Carregar Coluna de Imagens?",
              tooltip:"Informar se deseja carregar na grade.",
              type:"toggle",
              required: false,
              defaultValue:false,
              hideFunction:(form:FormGroup)=>{
               let type:NavItemEntitiesTypeEnum = form.get('type').value;
               if ( type!=NavItemEntitiesTypeEnum.gridview ){
                 return true;
               }else{
                 return false;
               }
             }
            },
            {
              name:"showImageDataBase64",
              description: "Carregar Coluna Base 64",
              title:"Carregar Coluna de Imagens em Base64?",
              tooltip:"Informar se deseja carregar na grade em Base 64.",
              type:"toggle",
              required: false,
              defaultValue:false,
              hideFunction:(form:FormGroup)=>{
               let type:NavItemEntitiesTypeEnum = form.get('type').value;
               if ( type!=NavItemEntitiesTypeEnum.gridview ){
                 return true;
               }else{
                 return false;
               }
             }
            },
            {
              name:"component",
              description: "Componente Customizado",
              title:"Componente Customizado",
              tooltip:"Informar o Componente Customizado da TemAPI",
              type:"select",
              hideFunction:(form:FormGroup)=>{
               let type:NavItemEntitiesTypeEnum = form.get('type').value;
               if ( type!=NavItemEntitiesTypeEnum.component ){
                 return true;
               }else{
                 return false;
               }
             },
              options:Array.from(REGISTRY).map(([key, value])=>{return {key:key,value:key}})
            },
            {
              name:"properties",
              description: "Propriedade da Tela",
              title:"Propriedades de Incialização da Tela",
              tooltip:"Informar o JSON de propriedade da Tela",
              type:"string",
              hideFunction:(form:FormGroup)=>{
               let type:NavItemEntitiesTypeEnum = form.get('type').value;
               if ( type!=NavItemEntitiesTypeEnum.component ){
                 return true;
               }else{
                 return false;
               }
             }
            },
            {
              name:"formulaPropriedade",
              description: "Fórmula para Propriedade da Tela",
              title:"Fórmula Propriedades de Incialização da Tela",
              tooltip:"Informar uma fórmula da TemAPI o JSON de propriedade da Tela",
              type:"string",
              hideFunction:(form:FormGroup)=>{
               let type:NavItemEntitiesTypeEnum = form.get('type').value;
               if ( type!=NavItemEntitiesTypeEnum.component ){
                 return true;
               }else{
                 return false;
               }
             }
            }
           ]
           
           this.subIcon =  this.iconServices.getIcons(null).subscribe(d=>{
            this.icons = d;
          });
        });
      });

      this.form = this.formBuilder.group({
          type: new FormControl<string>({value:null,disabled:true},[Validators.required]),
          displayName:new FormControl<string>(null,Validators.required),
          iconName: new FormControl<string>(null),
          svgIconName: new FormControl<string>(null),
          route:new FormControl<string>(null),
          visible:new FormControl<boolean>(null),
          instanceDynamicView: new FormControl<boolean>(null),
          entities:formBuilder.array([])
      })
  }
  ngOnDestroy(): void {
    if ( this.subIcon!= null ){this.subIcon.unsubscribe();}
  }


  getIconsInfo(value: string){
    this.selectedTypeIcon = value;
    this.changeIconForm(this.selectedTypeIcon);

  }

  changeIconForm(icon:string){
    if ( icon == 'google'){
      this.form.get('iconName').addValidators(Validators.required);
      this.form.get('svgIconName').removeValidators(Validators.required);
    }else{
      this.form.get('svgIconName').addValidators(Validators.required);
      this.form.get('iconName').removeValidators(Validators.required);
    }
  }

  ngOnInit(): void {
      this.form.valueChanges.subscribe(d=>{
          this.disableSave = false;
      })

  }

  cancelar(){
    this.showEditView=false;
    this.selectedRow=null;
    this.entities = [];
    this.form.reset();
    this.disableSave = true;
  }
  
  salvar(){
      if ( this.form.valid && this.selectedTypeIcon != null ){
        this.menuLoading = true;
        this.disableSave = true;
        this.showEditView = false;
        this.changeOrCreateMenu().then(d=>{
          this.menuService.getNewMenu().then(async (d:NavItem[])=>{
            this.setTreeData(d);
            this.menuService.getMenus();
            });
        }).finally(()=>this.menuLoading = false);
      }else{
        this.snackbar.showError('Campos Obrigatórios não preenchidos.')
      }
  }
  
  removeSpaces(value:string){
    
    if ( value != null ){
        return value.replace(" ","").toLowerCase();
    }
    return "";
  }
  
  changeOrCreateMenu() {
  
    return new Promise((resolve,reject)=>{
      try{
        let ob={
          entityName:"Mktpmenu",
          DESCRIPTION: this.form.get("displayName").value,
          PROPERTIES: JSON.stringify(this.createProperties()) ,
          ENABLE: "S"
        }
  
        if ( this.mode == 'insert'){
            ob['IDMENU']=this.removeSpaces(this.form.get("displayName").value);
            ob['TYPE']=this.selectedTypeItem;
        }else{
            ob['NUMENU']=this.selectedRow.nuMenu;
        }
  
        this.http.post(ob, "JsonBrokerServices/save", true).subscribe(
          {
            next:(d)=>{
              let nuMenu = d['NUMENU'];
              if ( this.mode == 'insert'){
                  this.createMenuLig(nuMenu);
              }
              resolve(true);
            },
            error:(error)=>{
                throw error;
            }
          })
      }catch(error){
        throw error;
      }
      
    })
      
  }

  get type(){
    return this.form.get("type").value;
  }

  set type(val){
    this.form.get('type').setValue(val);
  }

  getTypeItem(evento){
      this.selectedTypeItem = this.type;
      if (this.selectedTypeItem == 'P' || this.selectedTypeItem == 'R'){
        this.hideProperties = true;
      }else{
        this.hideProperties  = false;
      }
  }

  getNextSequence(){
      // bug antigo: Math.max() de lista vazia retorna -Infinity → sequence NaN
      const children = this.selectFatherItem != null ? this.selectFatherItem.children : null;
      if ( children == null || children.length === 0 ){
        return 1;
      }
      return Math.max(...children.map(o => o.sequence))+1;
  }

  createMenuLig(nuMenu: any) {

    let ob={
        entityName:"Mktpmenulig",
        NUMENU: this.selectFatherItem.nuMenu,
        NUMENUF: nuMenu,
        ENABLE: 'S',
        SEQUENCE:this.getNextSequence(),
        PROPERTIES:""
      }
      this.http.post(ob, "JsonBrokerServices/save", true).subscribe();

  }

  removeItem(node: NzTreeNode){

      const navItem: NavItem = this.getNavItem(node);
      this.selectedRow = navItem;

      try {
        this.dialogServices.title = "Exclusão de Dados";
        this.dialogServices.openNewDialog(
          "Excluir o menu selecionado?",
          () => {
            let remove:Object = {};
            remove["entityName"] = "Mktpmenu"
            remove["condition"] = "NUMENU = " + navItem.nuMenu;
              this.menuLoading = true;
              this.http.post(remove,"JsonBrokerServices/remove",false).subscribe({
                  next:(data)=>{

                    this.disableSave = true;
                    this.showEditView = false;
                    this.entities = [];
                    this.selectFatherItem = null;
                    this.selectedRow = null;
                    this.form.reset();

                    this.menuService.getNewMenu().then(async (d:NavItem[])=>{
                      this.setTreeData(d);
                      this.menuLoading = false;
                    }).finally(()=>this.menuLoading = false)},
                  error:(error)=>{this.menuLoading = false; throw error;},
                  complete:()=>{this.menuLoading = false}
              });
          });
      } catch (Exception) {
        this.menuLoading = false
        throw Exception;
      }

  }

  /** NavItem armazenado no origin do nó da árvore NZ */
  private getNavItem(node: NzTreeNode): NavItem {
      return node != null && node.origin != null ? node.origin['navItem'] as NavItem : null;
  }

  createProperties() {
      let properties = {
          displayName: this.form.get('displayName').value,
          id: this.removeSpaces(this.form.get('displayName').value),
          route: this.removeSpaces(this.form.get('displayName').value),
          visible: true
      }
      
      // if ( this.mode == "insert"){
      //   if ( this.type == "I" ){
      //     properties['instanceDynamicView']=true;
      //   }else{
      //     properties['instanceDynamicView']=this.form.get('instanceDynamicView').value;
      //   }
      // }
      
      properties['instanceDynamicView']=true;
      
      if (this.selectedTypeIcon=='google'){
        properties['iconName']=this.form.get('iconName').value;
      }else{
        properties['svgIconName']=this.form.get('svgIconName').value;
      }

      //if ( this.entities != null ){
      properties['entities']=this.entities;
      //}
      
      return properties;
      
  }

  canInsertNode(node: NzTreeNode){
      const navItem = this.getNavItem(node);
      return navItem != null && (navItem.type == 'R' || navItem.type=='P');
  }

  canRemoveNode(node: NzTreeNode){
    const navItem = this.getNavItem(node);
    return node.level > 0 && navItem != null && (navItem.children == null || navItem.children.length == 0);
  }

  canEditNode(node: NzTreeNode){
    return node.level > 0;
  }

  getEntityRows(){
      return this.entities;
  }

  editItem(node: NzTreeNode, event){

    this.showEditView=true
    this.entities = [];

    const navItem = this.getNavItem(node);
    this.selectedRow = navItem;
    this.mode = 'edit';

    this.entities = navItem.entities;
    if ( navItem.svgIconName != null ){
      this.selectedTypeIcon = 'svg';
    }else{
      this.selectedTypeIcon = 'google';
    }
    this.changeIconForm(this.selectedTypeIcon);
    this.formServices.refreshFormObject(this.form,this.selectedRow);
    this.getTypeItem(null);


  }

  insertItem(node: NzTreeNode){

    this.showEditView=true;
    this.selectFatherItem = this.getNavItem(node);
    this.selectedRow=null;
    this.entities = [];
    this.form.reset();

    if ( node.level == 0){
      this.type = 'R'
      this.typeItem.filter(a=>a.key !='R').map(d=>d.enable = false);
      this.typeItem.filter(a=>a.key =='R').map(d=>d.enable = true);
    }else{
      this.type = 'P'
      this.typeItem.filter(a=>a.key =='R').map(d=>d.enable = false);
      this.typeItem.filter(a=>a.key !='R').map(d=>d.enable = true);
    }

    this.mode = 'insert';
    this.getTypeItem(null);
    this.form.get('type').enable();
  }

  loadInstances(){
    return new Promise((resolve,reject)=>{
      
      let ob = {
        "entityName":"Mktpdic",
        "sql":`SELECT INSTANCENAME,INSTANCEDESC FROM MKTPDIC`
      }
     
      this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
        next:(data)=>{
          if ( data && data['SQL']){
              this.entityList  = data['SQL'];
              
          }
          resolve(true);
        },
        error:(error)=>{
          throw error;
        }
      });
    });
  }

}
